module.exports = __webpack_public_path__ + "static/media/deliveryIcon.fb4c150a.svg";